import Reveal from '@/components/base/Reveal';
import { beforeItems, afterItems } from '@/mocks/results';

export default function BeforeAfter() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            The Shift
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            What Changes When the Marketing System Works
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Before */}
          <Reveal>
            <div className="h-full rounded-2xl border border-white/8 bg-background-100 p-8 md:p-10">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-300 text-foreground-600">
                  <i className="ri-subtract-line text-xl"></i>
                </span>
                <h3 className="font-heading font-bold text-xl text-foreground-950">
                  Before
                </h3>
              </div>
              <ul className="mt-6 space-y-3">
                {beforeItems.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-sm text-foreground-600">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-background-300/60 text-foreground-500">
                      <i className="ri-close-line text-sm"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* After */}
          <Reveal delay={100}>
            <div className="h-full rounded-2xl border border-primary-500/30 bg-gradient-to-b from-background-200 to-background-100 p-8 md:p-10">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                  <i className="ri-add-line text-xl"></i>
                </span>
                <h3 className="font-heading font-bold text-xl text-foreground-950">
                  After
                </h3>
              </div>
              <ul className="mt-6 space-y-3">
                {afterItems.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 text-sm text-foreground-700">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <p className="mt-6 text-center text-xs text-foreground-600 max-w-2xl mx-auto">
            Typical areas Josh works to improve. Results vary by business and
            are not guaranteed.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
